import React, { useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

function EdicionUsoEnvasado(props) {
  const [editar, setEditar] = useState(props.editar);
  const [datosRow, setDatosRow] = useState(props.datosRow);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [disBtn, setDisBtn] = useState(false);
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setEditar(!editar);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  const EditarUso = async (e) => {
    setDisBtn(true);

    e.preventDefault();
    await fetch(UrlApi + "/envasado_usos/" + datosRow.id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uso: datosRow.uso,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setColorMensaje("#D4EFDF");
          setMensaje("El Uso se editó exitosamente !");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al editar el uso");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <>
      <Dialog
        fullWidth
        open={editar}
        onClose={() => handleClose()}
        maxWidth="md"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar Uso {datosRow.id}
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={EditarUso}>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12} py={1} mb={1}>
                <TextField
                  label="Uso"
                  name="uso"
                  size="small"
                  multiline
                  placeholder="..."
                  inputProps={{
                    maxLength: 300,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.uso}
                  onChange={almacenar}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid item>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item>
                <Button
                  type="submit"
                  color="success"
                  variant="contained"
                  disabled={disBtn}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EdicionUsoEnvasado;
